// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"159":"2b5ed560","2821":"2b5ed560","4173":"2b5ed560","5927":"fc38c5d5","7461":"2b5ed560","9313":"97be4f0d"}[chunkId] + ".chunk.css";
};